import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { apiClient, logoutRequest } from "@/lib/apiClient";

const AuthContext = createContext({
  email: null,
  setEmail: () => {},
  logout: async () => {},
  me: null,
  refreshMe: () => {},
  isSuperAdmin: false,
});

// Phase B: Der Session-Token liegt im httpOnly-Cookie (Browser). `authEmail` in localStorage ist nur
// noch ein Anzeige-/«eingeloggt»-Marker; die Wahrheit liefert /auth/me.
export function AuthProvider({ children }) {
  const [email, setEmailState] = useState(() => localStorage.getItem("authEmail"));
  const [sessionKey, setSessionKey] = useState(0);
  const [me, setMe] = useState(null);

  const refreshMe = useCallback(async () => {
    if (!localStorage.getItem("authEmail")) {
      setMe(null);
      return;
    }
    try {
      const res = await apiClient.get("/auth/me");
      setMe(res.data || null);
    } catch {
      setMe(null);
    }
  }, []);

  useEffect(() => {
    if (email) {
      localStorage.setItem("authEmail", email);
      refreshMe();
    } else {
      setMe(null);
    }
  }, [email, sessionKey, refreshMe]);

  // Iter250: Session-Zähler, damit Login mit gleicher E-Mail (z.B. nach Session-Ablauf)
  // Firma/Dashboard ohne Browser-Refresh neu lädt.
  const setEmail = (next) => {
    if (!next) {
      localStorage.removeItem("authEmail");
      localStorage.removeItem("authToken");
    }
    setSessionKey((k) => k + 1);
    setEmailState(next);
  };

  const logout = async () => {
    await logoutRequest();
    setEmail(null);
  };

  return (
    <AuthContext.Provider
      value={{
        email,
        token: email ? `session-${sessionKey}` : null,
        setEmail,
        logout,
        me,
        refreshMe,
        isSuperAdmin: !!me?.is_super_admin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
